import { ActivityLog } from "../api-model";

export class FeaturePublic extends ActivityLog {
    id: string;
    publicCd: string;
    featureType: number;
    teamcd?: string;
    staffcd?: string;
    delflg?: boolean;
}